/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ReportsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 72"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2">
        <path d="M40.5 31.5h30c0-16.566-13.431-30-30-30v30zM61.713 58.713c5.43-5.43 8.787-12.93 8.787-21.213h-30l21.213 21.213z" />
        <path d="M31.5 10.5c-16.566 0-30 13.434-30 30 0 26.814 32.49 39.936 51.213 21.213L31.5 40.5v-30z" />
      </g>
    </g>
  </svg>
);

export default ReportsIcon;
